import { RequestBatcher } from './request-batcher';
export const createExperiencesRequestBatcher = (config, httpClient)=>{
    var _requestWindowInMilliseconds;
    return new RequestBatcher((_requestWindowInMilliseconds = config.requestWindowInMilliseconds) != null ? _requestWindowInMilliseconds : 100, (request)=>httpClient.post('/v2/experiences/get', request)
    , canRequestsBeMerged, mergeRequests);
};
const canRequestsBeMerged = (pendingRequest, request)=>{
    return pendingRequest.context.application.salesChannelId === request.context.application.salesChannelId && pendingRequest.context.customer.loyaltyMemberIdHash === request.context.customer.loyaltyMemberIdHash;
};
const mergeRequests = (pendingRequest, request)=>{
    const clonedRequest = JSON.parse(JSON.stringify(pendingRequest));
    clonedRequest.context.journey.viewedEntities.current.push(...request.context.journey.viewedEntities.current);
    return clonedRequest;
};
